import LinkBlock from "./LinkBlock";
import { motion } from "framer-motion";
import React from "react";
import config from "@services/config";
import { contentSlideUp, parent, transition } from "@services/motionTransitions";

const emailSvg = (
  <svg className="h-12 w-12 text-whiteAccent md:h-16 md:w-16" fill="currentColor" viewBox="0 0 24 24">
    <path d="M12.042 23.648c-7.813 0-12.042-4.876-12.042-11.171 0-6.727 4.762-12.125 13.276-12.125 6.214 0 10.724 4.038 10.724 9.601 0 8.712-10.33 11.012-9.812 6.042-.71 1.108-1.854 2.354-4.053 2.354-2.516 0-4.08-1.842-4.08-4.807 0-4.444 2.921-8.199 6.379-8.199 1.659 0 2.8.876 3.277 2.221l.464-1.632h2.338c-.244.832-2.321 8.527-2.321 8.527-.648 2.666 1.35 2.713 3.122 1.297 3.329-2.58 3.501-9.327-.998-12.141-4.821-2.891-15.795-1.102-15.795 8.693 0 5.611 3.95 9.381 9.829 9.381 3.436 0 5.542-.93 7.295-1.948l1.177 1.698c-1.711.966-4.461 2.209-8.78 2.209zm-2.344-14.305c-.715 1.34-1.177 3.076-1.177 4.424 0 3.61 3.522 3.633 5.252.239.712-1.394 1.171-3.171 1.171-4.529 0-2.917-3.495-3.434-5.246-.134z" />{" "}
  </svg>
);

const twitterSvg = (
  <svg className="h-12 w-12 text-whiteAccent md:h-16 md:w-16" fill="currentColor" viewBox="0 0 24 24">
    <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
  </svg>
);

const Contact: React.FC = () => {
  return (
    <motion.div
      className="flex w-full flex-col flex-wrap items-center justify-around gap-x-8 gap-y-8 md:flex-row"
      variants={parent}
      animate="animate"
      initial="initial"
    >
      <motion.div className="w-full flex-1" variants={contentSlideUp} transition={transition}>
        <LinkBlock lien={`mailto:${config.email}`} logo={emailSvg} description={"Contactez-nous par email"} />
      </motion.div>
      <motion.p variants={contentSlideUp} transition={transition} className="text-xl font-bold uppercase text-whiteAccent md:text-2xl">
        ou
      </motion.p>
      <motion.div className="w-full flex-1" variants={contentSlideUp} transition={transition}>
        <LinkBlock
          lien={"https://twitter.com/messages/compose?recipient_id=845931919879667712"}
          logo={twitterSvg}
          description={"Envoyez-nous un message privé sur Twitter"}
        />
      </motion.div>
    </motion.div>
  );
};

export default Contact;
